module.exports = __webpack_public_path__ + "media/placeholders/slide-2025994e.jpg";